export const PRIMARY_CERTIFICATES_TYPE = 'Primary Certificates'
export const RESTRICTED_CERTIFICATES_TYPE = 'Restricted Certificates'

export const isPrimaryCertificateType = (type: string | undefined) =>
  type === PRIMARY_CERTIFICATES_TYPE || type === RESTRICTED_CERTIFICATES_TYPE
